import { inheritSerialization, autoserialize } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class Sublocation extends AbstractModel {
  @autoserialize
  locationId: number;

  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;
}
